export const DogGeneralCdpHandle = {
  DogWetFoodHandle: 'fur-hunde-nassfutter',
  DogDryFoodHandle: 'fur-hunde-trockenfutter',
  DogSnacksHandle: 'fur-hunde-snacks',
} as const;
